/**
 * Appends resize/compression query params to Unsplash source URLs so the browser downloads an
 * appropriately-sized file instead of the multi-megabyte original (these testimonial/review
 * avatars are only ever displayed at a few hundred pixels wide) - pure network-payload
 * optimization for Core Web Vitals (LCP/total byte weight) on mobile, zero visual change.
 */
export function optimizeUnsplashUrl(url, width = 600) {
  if (!url || !url.includes("images.unsplash.com")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}w=${width}&q=75&fit=crop&auto=format`;
}
